export default "__VITE_ASSET__BaabnI2f__"